// @flow

import * as React from 'react';
import {useEffect, useState} from 'react';

type OnlyRenderOnClientProps = {|
  children: React.Node,
  placeholder?: React.Node | null,
|};

export const OnlyRenderOnClient = ({
  children,
  placeholder = null,
}: OnlyRenderOnClientProps) => {
  const [mounted, setMounted] = useState();

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? children : placeholder;
};
